<template>
<v-card outlined rounded class="mt-4 mr-4" width="334">
    <v-card-text>
        <p class="text-h6 text--primary">
            {{totalSummary.title}}
        </p>
        <v-row class="d-flex align-content-start flex-wrap pt-4">
            <!-- <template v-for="item in itemList" :key="item.title"> -->
            <v-col class="text-center mt-4 mr-4 ml-4 pb-0 pt-0" v-for="item in itemList" :key="item.key">
                <v-avatar :color="item.color" size="62">
                    <v-icon large :color="item.colorText">mdi-{{item.icon}}</v-icon>
                </v-avatar>
                <p class="text-h6 text--primary mb-0 mt-1">
                    {{_formatData('chart', totalSummary.data[item.key], item.key)}}
                </p>
                <p v-if="item.unit" class="text-caption mt-n1">
                    {{item.title}} ({{item.unit}})
                </p>
                <p v-else class="text-caption mt-n1">
                    {{item.title}}
                </p>
            </v-col>
            <!-- </template> -->
        </v-row>
    </v-card-text>
</v-card>
</template>

<script>
import formatData from "../utils/formatData";
import colors from 'vuetify/lib/util/colors'
export default {
    data() {
        return {
            title: 'Summary',
            totalSummary: {
                data: {
                    totalWeightLoss: 0,
                    totalWorkoutMins: 0,
                    totalStep: 0,
                    totalPBWF: 0,
                    avgMBI: 0
                }
            },
            itemListDefault: [{
                    key: 'totalWeightLoss',
                    title: 'Weight loss',
                    unit: 'kg',
                    icon: 'scale-bathroom',
                    color: colors.green.lighten4,
                    colorText: colors.green.darken1
                }, {
                    key: 'totalWorkoutMins',
                    title: 'Workout',
                    unit: 'mins',
                    icon: 'dumbbell',
                    color: colors.purple.lighten4,
                    colorText: colors.purple.darken1
                }, {
                    key: 'totalStep',
                    title: 'Steps',
                    unit: '',
                    icon: 'shoe-print',
                    color: colors.pink.lighten4,
                    colorText: colors.pink.darken1
                },
                {
                    key: 'totalPBWF',
                    title: 'PBWF',
                    unit: 'serves',
                    icon: 'food-apple',
                    color: colors.orange.lighten4,
                    colorText: colors.orange.darken1
                }
            ]
        };
    },
    created() {
        this.id = this.$route.params.id;
        this.totalSummary = this.$attrs.totalSummaryInfo;
    },
    computed: {
        itemList(){
            if( this.$attrs.itemList ){
                return this.$attrs.itemList
            }
            else{
                return this.itemListDefault;
            }
        }
    },
    methods: {
        _formatData(type, value, mod) {
            return formatData(type, value, mod);
        },

        //router
        goToGroupList(item, type) {
            if (type == "summary") {
                this.$router.push(`/challengesummary/${this.id}`);
            } else if (type == "verify") {
                this.$router.push(`/challengeverify/${this.id}`);
            } else {
                this.$router.push(`/challenge/${this.id}`);
            }
        },
        goToChallengeList() {
            this.$router.push(`/challenge`);
        }

    }
};
</script>
